var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userInfoWrap"},[_c('GoBack',{attrs:{"title":_vm.title,"nextPath":_vm.nextPath,"nextQuery":_vm.nextQuery}}),_c('SelectTab',{attrs:{"selectTabList":_vm.selectTabList,"curSelectTab":_vm.curSelectTab},on:{"selectTab":_vm.selectTab}}),(_vm.curSelectTab === '个人信息')?_c('InfoBase'):_c('InfoAddress')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }